import details, { en as detailsEN, ca as detailsCA } from './details'
import features, { en as featuresEN, ca as featuresCA } from './features'
import header, { en as headerEN, ca as headerCA } from './header'

export default {
  details,
  header,
  features,
  project: 'Proyecto',
  program: 'Programa',
  sdg: 'Este {content} promueve los siguientes ODS',
  sdgEmpty: 'Se autocompletará al agregar recursos',
  titlePlaceholder: 'Agrega un título a tu {content}',
  titleInfoTitle: 'Título de {content}',
  titleInfo: 'Al pensar en el título de tu {content} ten en cuenta que sea anticipatorio y orientador respecto del tema, especialmente para facilitar la búsqueda a docentes. Idealmente, debe generar interés y curiosidad en los estudiantes. ¡Y  no debe ser demasiado extenso!',
  udlLabel: 'Pautas DUA',
  udlPlaceholder: 'Selecciona una pauta',
  udlEmptyOption: 'Ninguna',
  levelLabel: 'Nivel y año',
  levelPlaceholder: 'Selecciona un nivel',
  levelEmptyOption: 'Ninguno',
  gradeLabel: 'Año',
  gradePlaceholder: 'Selecciona un año',
  gradeEmptyOption: 'Ninguno',
  orderResourcesInfoTitle: 'Recursos que conforman este proyecto',
  orderResourcesInfo: 'Cliquea aquí para ordenar de un modo distinto los recursos que fuiste creando.',
  addNewResource: 'Agregar nuevo recurso',
  educationalProgramInfoTitle: '¡Recomendación para crear un óptimo {content}!',
  resourcesInfo: 'Podrás organizar el orden de los recursos como desees.',
  resources: 'Recursos que conforman este {content}',
  orderResources: 'Personalizar el orden de los recursos',
  unpublishModal: {
    title: 'Despublicar contenido',
    msg: '¿Estás seguro que deseas despublicar el contenido <h2 class="text-normal bold">"{contentTitle}"</h2>?',
    cancel: 'Cancelar',
    unpublish: 'Despublicar'
  }
}

export const en = {
  details: detailsEN,
  header: headerEN,
  features: featuresEN,
  project: 'Project',
  program: 'Program',
  sdg: 'This {content} promotes the following SDGs',
  sdgEmpty: 'Will autocomplete when adding resources',
  titlePlaceholder: 'Add a title to your {content}',
  titleInfoTitle: 'Title of {content}',
  titleInfo: 'When thinking about the title of your {content} keep in mind that it should be anticipatory and orienting with respect to the topic, especially to facilitate the search for teachers. Ideally, it should generate interest and curiosity in students, and it should not be too long!',
  udlLabel: 'UDL Guidelines',
  udlPlaceholder: 'Select a guideline',
  udlEmptyOption: 'None',
  levelLabel: 'Level and Year',
  levelPlaceholder: 'Select a level',
  levelEmptyOption: 'None',
  gradeLabel: 'Year',
  gradePlaceholder: 'Select a year',
  gradeEmptyOption: 'None',
  orderResourcesInfoTitle: 'Resources that make up this project',
  orderResourcesInfo: 'Click here to sort the resources you have created in a different order.',
  addNewResource: 'Add new resource',
  educationalProgramInfoTitle: 'Tip to create an optimal {content}!',
  resourcesInfo: 'You can arrange the order of the resources as you wish.',
  resources: 'Recursos que conforman este {content}',
  orderResources: 'Customize the resource order',
  unpublishModal: {
    title: 'Unpublish content',
    msg: 'Are you sure you want to unpublish the <h2 class="text-normal bold">"{contentTitle}"</h2> content?',
    cancel: 'Cancel',
    unpublish: 'Unpublish'
  }
}

export const ca = {
  details: detailsCA,
  header: headerCA,
  features: featuresCA,
  project: 'Projecte',
  program: 'Programa',
  sdg: 'Aquest {content} promou els següents ODS',
  sdgEmpty: 'S\'autocompletarà en agregar recursos',
  titlePlaceholder: 'Agrega un títol al teu {content}',
  titleInfoTitle: 'Títol de {content}',
  titleInfo: 'En pensar en el títol del teu {content} tingues en compte que sigui anticipatori i orientador respecte del tema, especialment per facilitar la cerca a docents. Idealment, ha de generar interès i curiositat en els estudiants. I no ha de ser massa extens!',
  udlLabel: 'Pautes DUA',
  udlPlaceholder: 'Seleccioneu una pauta',
  udlEmptyOption: 'Cap',
  levelLabel: 'Nivell i any',
  levelPlaceholder: 'Seleccioneu un nivell',
  levelEmptyOption: 'Cap',
  gradeLabel: 'Any',
  gradePlaceholder: 'Seleccioneu un any',
  gradeEmptyOption: 'Cap',
  orderResourcesInfoTitle: 'Recursos que conformen aquest projecte',
  orderResourcesInfo: 'Fes cli aquí per ordenar d\'una manera diferent els recursos que has anat creant.',
  addNewResource: 'Agregar nou recurs',
  educationalProgramInfoTitle: 'Recomanació per a crear un òptim {content}!',
  resourcesInfo: 'Podràs organitzar l\'ordre dels recursos com desitgis.',
  resources: 'Recursos que conformen aquest {content}',
  orderResources: 'Personalitzar l\'ordre dels recursos',
  unpublishModal: {
    title: 'Despublicar contingut',
    msg: 'Estàs segur que desitges despublicar el contingut <h2 class="text-normal bold">"{contentTitle}"</h2>?',
    cancel: 'Cancel·lar',
    unpublish: 'Despublicar'
  }
}
